import React, {useState, useEffect} from 'react'
import { DisplayContainer, DisplayHeader, DisplayForm, DisplayOffers, HeaderTitle, HeaderTag, EffectiveContainer, EffectiveDate, ProductType, RateTableFooter, FormButtonLink, DisclosureLink, LoadingContainer } from './Styles/SavingsDisplay';

import {Form, FormLabel, FormButton, FormInput, FormSelect} from './Styles/SavingsDisplay'

import {Offer, Display, OfferImage, InfoColumn, OfferAPY, OfferInfo, APY, InfoItem, DisclaimerContainer} from './Styles/SavingsDisplay'

// React Hook Forms Implementation
import {useForm} from 'react-hook-form'

// Borrowing Advertiser Disclosure display from loan display
import {AdvertDisclaimer} from '../LoanDisplay/LoanDisplay'

//Using getToken to keep Dev/Production tokens in order
import {getSavingsToken, getToken} from '../../Helpers/apicall'
import Blog from '../Blog';

import {Disclaimer} from '../LoanDisplay/Offer/LoanOffer'
import {statusOptions as creditOptions} from '../Forms/Formik/FormComponents/CreditInformation'

import {DisclosureOverlay, DisclosureContainer, DisclosureText} from './Styles/SavingsDisplay'

import {AiOutlineCloseCircle, AiFillCloseCircle} from 'react-icons/ai'

import Delayed from '../../Helpers/Delay'

import './Styles/SavingsDisplay.css'

const depositOptions = [{key: 'Less than $1,000', value: 0}, {key: '$1,000 - $5,000', value: 1000}, {key: '$5,000+', value: 5000}]

const token = getSavingsToken()

const submitSavingsOfferClick = () => {
    if(window.dataLayer){
        window.dataLayer.push({
            event: 'savings_account',
        })
    }
}

const SavingsOffer = ({offer}) => {
    let date = offer.details.effectiveAsOf ? new Date(offer.details.effectiveAsOf) : null;

    let displayDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear();

    let productType = offer.productType.replace(/_/g, ' ');

    return (
        <Offer>
            <EffectiveContainer>
                <ProductType>{productType.charAt(0).toUpperCase() + productType.slice(1)}</ProductType>
                <EffectiveDate>As of : {displayDate}</EffectiveDate>
            </EffectiveContainer>
            <Display>
                <OfferImage src={offer.partner.imageUrl}/>
                <OfferAPY><APY>{offer.details.rate.toFixed(2)}%</APY><p style={{marginTop: '0'}}>APY</p></OfferAPY>
                <OfferInfo>
                    <InfoColumn>
                        <InfoItem>Monthly Fee: ${offer.details.monthlyFee}</InfoItem>
                        <InfoItem>Check Writing: {offer.details.checkWriting ? 'Yes' : 'No'}</InfoItem>
                    </InfoColumn>
                    <InfoColumn>
                        <InfoItem>Min balance to avoid fees: ${offer.details.minimumDeposit}</InfoItem>
                        <InfoItem>Min balance to Earn APY: ${offer.details.minimumDepositWithFees}</InfoItem>
                    </InfoColumn>
                </OfferInfo>
                <FormButtonLink onClick={() => submitSavingsOfferClick()} rel="noopener noreferrer" target="_blank" href={offer.url}>View Offer</FormButtonLink>
            </Display>
            <DisclaimerContainer>
                <Disclaimer name={offer.details.name} content={offer.disclaimer.replace(/<[^>]*>?/gm, '') + ' | ' + offer.details.details.replace(/<[^>]*>?/gm, '')}/>
            </DisclaimerContainer>
        </Offer>
    )
}

const DisclosureModal = ({content, title, setShow}) => {
    const [hover, setHover] = useState(false)

    return (
        <DisclosureOverlay>
            <DisclosureContainer>
                <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                {
                    !hover ? <AiOutlineCloseCircle onClick={() => setShow(s => !s)} className="close-icon" onMouseEnter={() => setHover(s => !s)} onMouseLeave={() => setHover(s => !s)}/> : <AiFillCloseCircle onClick={() => setShow(s => !s)} className="close-icon" onMouseEnter={() => setHover(s => !s)} onMouseLeave={() => setHover(s => !s)}/>
                }
                </div>
                <DisclosureText title={true}>{title}</DisclosureText>
                {
                    content.map(paragraph => {
                        return (
                            <DisclosureText>{paragraph}</DisclosureText>
                        )
                    })
                }
            </DisclosureContainer>
        </DisclosureOverlay>
    )
}

const SavingsDisplay = ( ) => {

    // Token for Production / Testing Even

    const [offers, setOffers] = useState()
    const [typeOptions, setTypeOptions] = useState()

    const [zipCode, setZipCode] = useState('10109')

    const [showDisclosures, setShowDisclosures] = useState(false)

    const [loading, setLoading] = useState(false)

    let genericCall = {
        "productTypes": [
          "savings"
        ],
        "personalInformation": {
          "zipcode": '10010',
        },
        "creditInformation": {
          "providedCreditRating": 'excellent'
        },
        "savingsInformation": {
          "minDepositAmount": 1000
        },
    }

    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
            token,
      };

    const getSavingsOffers = (callObj) => {
        setLoading(true);
        fetch('https://api.evenfinancial.com/leads/rateTables', {
            method: 'POST',
            body: JSON.stringify(callObj),
            headers,
        }).then(res => {return res.json()}).then(res => {
            if(res.savingsOffers && res.savingsOffers.length >= 1){
                updateTypeOptions(res.savingsOffers)
                setOffers(res.savingsOffers)
            }else {
                setOffers(defaultResponse.savingsOffers)
                updateTypeOptions(defaultResponse.savingsOffers)
            }
            setLoading(false);
        })
    }

    const {register, handleSubmit} = useForm();

    const onSubmit = data => {
        const body = {
            "productTypes": [
              "savings"
            ],
            "personalInformation": {
              "zipcode": data.zipcode,
            },
            "creditInformation": {
              "providedCreditRating": data.providedCreditRating
            },
            "savingsInformation": {
              "minDepositAmount": parseInt(data.minDepositAmount)
            },
        }

        getSavingsOffers(body)
    }

    const onlyUnique = (value, index, self) => {
        return self.indexOf(value) === index;
    }

    const updateTypeOptions = (offers) => {
        let types = [];
        offers.map(offer => types.push(offer.productType))
        let filteredTypes = types.filter(onlyUnique)
        setTypeOptions(filteredTypes);
    }


    useEffect(() => {
        getSavingsOffers(genericCall)
    }, [])

    

    return (
        <>
        {
            showDisclosures ? <DisclosureModal setShow={setShowDisclosures} title={'Disclosures'} content={tableDisclosures} /> : null
        }
        <DisplayContainer>
            <DisplayHeader>
                <HeaderTitle>Find a savings account.</HeaderTitle>
                <HeaderTag>Choose the offer that best fits your wants and needs!</HeaderTag>
            </DisplayHeader>
            <DisplayForm>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <FormLabel>Zip Code<FormInput value={zipCode} onChange={(e) => setZipCode(e.target.value)} ref={register} name="zipcode"/></FormLabel>
                    <FormLabel>Deposit Amount<FormSelect ref={register} name="minDepositAmount">
                        {depositOptions.map((option, i) => {
                            return (
                                <option key={i} value={option.value}>{option.key}</option>
                            )
                        })}
                    </FormSelect></FormLabel>
                    <FormLabel>Credit Rating<FormSelect ref={register} name="providedCreditRating">
                        {creditOptions.map((option, i) => {
                            return (
                                <option key={i} value={option.value}>{option.key}</option>
                            )
                        })}
                    </FormSelect></FormLabel>
                    {/* {typeOptions && typeOptions.length >= 1 ? <FormLabel>Product Type<FormSelect ref={register} name="productType">
                        {
                            typeOptions.map((option, i) => {
                                return (
                                    <option key={i} value={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</option>
                                )
                            })
                        }
                    </FormSelect></FormLabel> : null} */}
                    <FormButton type="submit">Search</FormButton>
                </Form>
            </DisplayForm>
            <AdvertDisclaimer/>
            <DisplayOffers>
                {
                    !loading && offers && offers.length >= 1 ? offers.map((offer, i) => {
                        return (
                            <SavingsOffer key={i} offer={offer}/>
                        )
                    }) : <Delayed loading={loading}><LoadingContainer></LoadingContainer></Delayed>
                }
                <RateTableFooter>
                    <DisclosureLink onClick={() => setShowDisclosures(s => !s)}>Disclosures</DisclosureLink>
                </RateTableFooter>
            </DisplayOffers>
        </DisplayContainer>
        <Blog/>
        </>
    )

}

export default SavingsDisplay;



const tableDisclosures = [`The offers that appear are from companies which FIG Marketplace and its partners receive compensation. This compensation may influence the selection, appearance, and order of appearance of the offers listed below. However, this compensation also facilitates the provision by FIG Marketplace of certain services to you at no charge. The offers shown below do not include all financial services companies or all of their available product and service offerings.`,`The listings that appear on this page are from companies from which FIG Marketplace and its
affiliates may receive compensation, which may impact how, where and in what order products
appear. These listings do not include all companies or all available products. Neither FIG nor this website endorses or recommends any companies or products.`,
`APY stands for Annual Percentage Yield. It’s different from interest rate because it takes into
account compounding interest. APY is subject to change before and after account opening.`,
`MMA stands for Money Market Account. It’s a savings and checking hybrid, allowing you to
earn interest and use checks 6 times a month.`, `A high interest checking account has features of both savings and checking accounts allowing for interest to be paid on the money in your account balance. These accounts may have certain additional requirements, exclusions, fees and certain minimums in order to earn the interest rate. Please make sure to review the details and Terms and Conditions for each provider.`, `There may be certain minimum deposit and/or other funding requirements as well as restrictions placed in order to open an account and/or to earn stated Annual Percentage Yield. Maximum balance limits may also apply. Please review details and any terms and conditions on each provider's website.`];

const defaultResponse = {"uuid":"15aa02f7-6409-49d5-b598-197847b66ddd","leadUuid":"4bfc80ae-f116-4687-865c-ee6e5df6f931","creditCardOffers":[],"lifeInsuranceOffers":[],"lineOfCreditOffers":[],"loanOffers":[],"mortgageOffers":[],"savingsOffers":[{"uuid":"29428964-5ba0-4109-9ce6-6cac33d69821","partner":{"uuid":"7ff0c58a-2480-45aa-8aa4-d7350e85c51e","name":"Nationwide My Savings","description":" It’s hard to beat an account with 1.40% APY. Watch your savings grow even faster with interest compounded daily and enjoy no minimum balance requirements and no maintenance fees. This is the better way to save.","disclaimer":"Accounts offered by Axos Bank, Member FDIC","supportsPersonalizedOffers":false,"supportsPreSelect":false,"shouldDisplayPreSelect":true,"imageUrl":"https://s3.amazonaws.com/images.evenfinancial.com/logos/prod/nationwide_high_yield_savings.png"},"productType":"savings","productSubType":"savings_account","url":"https://offers.evenfinancial.com/ref/50823048-13f2-4d6d-be3a-61b336da9aed","recommendationScore":170,"disclaimer":"Accounts offered by Axos Bank, Member FDIC","details":{"name":"Nationwide My Savings","description":"Watch your savings grow even faster with interest compounded daily and enjoy no minimum balance requirements and no maintenance fees. This is the better way to save.","details":"Watch your savings grow even faster with interest compounded daily and enjoy no minimum balance requirements and no maintenance fees. This is the better way to save.","rate":0.4,"annualPercentYield":0.4,"compoundingMethod":"continuous","minimumDeposit":0,"minimumDepositWithFees":0,"monthlyFee":0,"checkWriting":false,"effectiveAsOf":"2020-10-08T12:00:00Z"}},{"uuid":"8e360037-7576-45f7-87fa-5ff137f54d2f","partner":{"uuid":"4e962a55-eae0-43ee-b218-34480e1ae6b5","name":"Aspiration Cash Management Account","description":"The Aspiration Spend & Save Account is a cash management account offering up to 1.00% APY interest, unlimited free ATM withdrawals from the Allpoint network, all extra services (such as wires) provided at cost, and your own personal People/Planet impact score.","disclaimer":"The Aspiration Spend Account and the Aspiration Save Account are part of a cash management account offering of Aspiration Financial, LLC (“Aspiration”), an SEC-registered broker dealer and member FINRA/SIPC.","supportsPersonalizedOffers":false,"supportsPreSelect":false,"shouldDisplayPreSelect":true,"imageUrl":"https://images.evenfinancial.com/logos/aspiration/aspiration.jpg"},"productType":"savings","productSubType":"cash_management_account","url":"https://offers.evenfinancial.com/ref/52b7c239-7830-4b70-96d4-d194ca2d88bc","recommendationScore":100,"disclaimer":"The Aspiration Spend Account and the Aspiration Save Account are part of a cash management account offering of Aspiration Financial, LLC (“Aspiration”), an SEC-registered broker dealer.","details":{"name":"Aspiration Spend and Save Account","description":"To earn 1.00% APY interest on Aspiration Save Account balances in any calendar month, an external deposit of at least $1,000 in that calendar month into any Aspiration cash management account or investment account is required. If the external deposit requirement cannot be met, the account owner can qualify for 1.00% APY on Aspiration Save Account balances in any calendar month if there is a single end of day Aspiration Save Account balance of $10,000 or more during that calendar month.","details":"The deposits at the Banks are eligible for insurance by the Federal Deposit Insurance Corporation (FDIC), subject to FDIC insurance coverage limits.","rate":1,"annualPercentYield":1,"compoundingMethod":"annually","minimumDeposit":0,"minimumDepositWithFees":0,"monthlyFee":0,"checkWriting":false,"effectiveAsOf":"2020-04-15T12:00:00Z"}},{"uuid":"a17ed1fa-f42d-42ab-95ea-fd96942e9303","partner":{"uuid":"87128a39-ce60-42b8-a12f-9dd2c1281173","name":"Empower Savings - Demand","description":"Empower is an award-winning mobile app that makes it easy and effortless to budget, spend, and save more wisely. It’s like having a personalized financial expert right in your pocket. </br> </br>\n1. Automatic Savings: Save without even trying. Just set your weekly savings target and watch your balance rise. </br> \n2. Interest Checking: Enjoy 0.20% APY* with no account minimums, no overdraft fees and unlimited withdrawals. </br> \n3. Painless Budgeting & Spend Tracking: Track your spending automatically with our intuitive budgeting tools and real time alerts. </br>\n4. Smart Recommendations: Get proactive notifications about bank fees, bill increases, missed bills and credit utilization. \n","disclaimer":"* Banking services provided by nbkc bank, Member FDIC. 0.20% Annual Percentage Yield (APY) may change at any time. APY as of Jan 01, 2021. Empower charges an auto-recurring monthly subscription fee of $8 for access to the full suite of money management features offered on the platform after your first 14 days.\n","supportsPersonalizedOffers":false,"supportsPreSelect":false,"shouldDisplayPreSelect":true,"imageUrl":"https://s3.amazonaws.com/images.evenfinancial.com/logos/prod/empower_savings_-_demand-270.png"},"productType":"savings","productSubType":"high_interest_checking","url":"https://offers.evenfinancial.com/ref/72bbffda-8ef5-4633-92bf-78457059395c","recommendationScore":25,"disclaimer":"* Banking services provided by nbkc bank, Member FDIC. 0.20% Annual Percentage Yield (APY) may change at any time. APY as of January 25, 2021. Empower charges an auto-recurring monthly subscription fee of $8 for access to the full suite of money management features offered on the platform. The subscription fee will apply (a) after the 14-day free trial concludes for first-time customers, and (b) immediately for customers returning for a second or subsequent subscription.","details":{"name":"Empower Interest Checking","description":"Empower is an award-winning mobile app that makes it easy and effortless to budget, spend, and save more wisely. It’s like having a personalized financial expert right in your pocket. </br> </br>\n1. Automatic Savings: Save without even trying. Just set your weekly savings target and watch your balance rise. </br> \n2. Interest Checking: Enjoy 0.20% APY* with no account minimums, no overdraft fees and unlimited withdrawals. </br> \n3. Painless Budgeting & Spend Tracking: Track your spending automatically with our intuitive budgeting tools and real time alerts. </br>\n4. Smart Recommendations: Get proactive notifications about bank fees, bill increases, missed bills and credit utilization. \n","details":"Empower is an award-winning mobile app that makes it easy and effortless to budget, spend, and save more wisely. It’s like having a personalized financial expert right in your pocket. </br> </br>\n1. Automatic Savings: Save without even trying. Just set your weekly savings target and watch your balance rise. </br> \n2. Interest Checking: Enjoy 0.20% APY* with no account minimums, no overdraft fees and unlimited withdrawals. </br> \n3. Painless Budgeting & Spend Tracking: Track your spending automatically with our intuitive budgeting tools and real time alerts. </br>\n4. Smart Recommendations: Get proactive notifications about bank fees, bill increases, missed bills and credit utilization. \n","rate":0.2,"annualPercentYield":0.2,"compoundingMethod":"daily","minimumDeposit":0,"minimumDepositWithFees":0,"monthlyFee":8,"checkWriting":false,"effectiveAsOf":"2021-01-25T12:00:00Z"}}],"specialOffers":[],"pendingOriginators":[],"pendingResponses":[]}